import { Navigation } from "@/components/Navigation";
import { Card } from "@/components/ui/card";
import { FileText, Book, Info } from "lucide-react";
import { Session } from "@supabase/supabase-js";

interface DocumentationProps {
  session: Session | null;
}

const Documentation = ({ session }: DocumentationProps) => {
  const docs = [
    {
      title: "Getting Started",
      description: "Learn the basics of SkuHub and how to get started.",
      icon: Book,
    },
    {
      title: "API Documentation",
      description: "Detailed documentation for the SkuHub API.",
      icon: FileText,
    },
    {
      title: "Best Practices",
      description: "Learn how to make the most of SkuHub.",
      icon: Info,
    },
  ];

  return (
    <div className="min-h-screen bg-skuhub-navy">
      <Navigation session={session} />
      <div className="container mx-auto px-4 py-24">
        <h1 className="text-4xl font-bold text-white mb-8">Documentation</h1>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {docs.map((doc) => (
            <Card key={doc.title} className="p-6 bg-white/5 backdrop-blur-sm border-white/10">
              <div className="flex items-start space-x-4">
                <doc.icon className="h-6 w-6 text-skuhub-coral" />
                <div>
                  <h3 className="text-lg font-semibold text-white">{doc.title}</h3>
                  <p className="text-gray-400 mt-2">{doc.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Documentation;
